import React, { useEffect } from 'react';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { WelcomeVoucherProps } from '@components/catalog/welcome-voucher/welcome-voucher';
import ConditionalWrapper from '@components/common/conditional-wrapper/conditional-wrapper';
import { useSmartBannerVisibilityManager } from '@hooks/smart-banner-v2/use-smart-banner-visibility-manager';
import { useSmartBannerV2 } from '@hooks/smart-banner-v2/use-smart-banner-v2';
import { BANNER_SIZE } from '@constants/smart-banner-v2';

const SmallSmartBanner = dynamic(
  () => import('@components/molecules/smart-banner/v2/small-smart-banner/small-smart-banner'),
  { ssr: false },
);
const BigSmartBanner = dynamic(
  () => import('@components/molecules/smart-banner/v2/big-smart-banner/big-smart-banner'),
  { ssr: false },
);

const SmartBannerWrapperV2: React.FC<WelcomeVoucherProps> = () => {
  const { shouldDisplaySmallSmallBanner, visibilityState, handleSmartBannerClose } = useSmartBannerVisibilityManager();
  const { trackBannerView } = useSmartBannerV2();

  useEffect(() => {
    trackBannerView();
  }, [trackBannerView]);

  return (
    <ConditionalWrapper
      condition={visibilityState.show}
      wrap={(children) => (
        <div
          style={shouldDisplaySmallSmallBanner ? { height: '5rem' } : undefined}
          className={clsx({ hasSmartBanner: shouldDisplaySmallSmallBanner })}
        >
          {children}
        </div>
      )}
    >
      {visibilityState.variant === BANNER_SIZE.SMALL ? (
        <SmallSmartBanner onCloseBannerClick={handleSmartBannerClose} />
      ) : (
        <BigSmartBanner onCloseBannerClick={handleSmartBannerClose} />
      )}
    </ConditionalWrapper>
  );
};

export default SmartBannerWrapperV2;
